
export default {
  name: 'LogoGrid',
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isNewLogoGridFormat() {
      return JSON.stringify(this.slice.items[0].logo) !== '{}'
    },
  },
}
